import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const ResendCodeButton = ({ onResend, disabled = false, email }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleResend = async () => {
    setIsLoading(true);
    setIsSuccess(false);

    try {
      // Simulate API call to resend OTP
      await new Promise(resolve => setTimeout(resolve, 1500));
      
      if (onResend) {
        await onResend();
      }
      
      setIsSuccess(true);
      setTimeout(() => setIsSuccess(false), 3000);
    } catch (error) {
      console.error('Error resending OTP:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (isSuccess) {
    return (
      <div className="flex items-center justify-center text-sm text-success">
        <Icon name="CheckCircle" size={16} className="ml-2" />
        <span>کد جدید ارسال شد</span>
      </div>
    );
  }

  return (
    <div className="text-center">
      <Button
        variant="ghost"
        size="sm"
        onClick={handleResend}
        disabled={disabled || isLoading}
        loading={isLoading}
        iconName="RefreshCw"
        iconPosition="right"
        className="text-primary hover:text-primary/80"
      >
        {isLoading ? 'در حال ارسال...' : 'ارسال مجدد کد'}
      </Button>
      {email && (
        <p className="text-xs text-muted-foreground mt-2">
          کد به {email} ارسال خواهد شد
        </p>
      )}
    </div>
  );
};

export default ResendCodeButton;